import { NavLink, Outlet } from 'react-router';
import { featuredCities, cityPages } from '../content/cityPages';

function SiteShell() {
  const allCities = Object.values(cityPages);

  return (
    <div className="site-shell">
      <Outlet />

      <footer className="site-footer">
        <div className="site-footer-inner">
          <p className="site-footer-copy">
            Weather, pubs, parks, and poor judgment. Built for sharing in the group chat.
          </p>

          <div className="site-footer-links">
            <NavLink to="/about" className="site-footer-link">
              About
            </NavLink>
            <NavLink to="/how-it-works" className="site-footer-link">
              How It Works
            </NavLink>
            <NavLink to="/contact" className="site-footer-link">
              Contact
            </NavLink>
            <a href="/privacy-policy.html" className="site-footer-link">
              Privacy
            </a>
          </div>

          <div className="site-footer-cities">
            {featuredCities.map((city) => (
              <NavLink key={city.slug} to={`/city/${city.slug}`} className="site-footer-link site-footer-city-link">
                {cityPages[city.slug].name}
              </NavLink>
            ))}
          </div>

          <nav className="visually-hidden" aria-label="All Australian city forecast guides">
            {allCities.map((city) => (
              <NavLink key={city.slug} to={`/city/${city.slug}`} className="site-footer-link">
                {city.name}
              </NavLink>
            ))}
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default SiteShell;
